export default __webpack_public_path__ + "static/media/locent.7cab6fd3.svg";